import ResponsiveAccordion from "@/components/ResponsiveAccordion";

/**
 * Product FAQ accordion. The same `faqs` array is passed to SEOHead, which
 * emits the FAQPage JSON-LD — so visible content and schema can never drift.
 */
export default function ProductFAQSection({ product }) {
  return (
    <section className="py-16 md:py-20 bg-gray-50" data-testid={`${product.slug}-faqs`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-brand-black tracking-tight mb-8 text-center">
          {`${product.name} FAQs`}
        </h2>
        <ResponsiveAccordion items={product.faqs} testIdPrefix={`${product.slug}-faq`} />
      </div>
    </section>
  );
}
